<template>
  <div>
    <v-row no-gutters>
      <v-app-bar
      color="primary"
      dark
  elevation="4"
>
MY BLUEFIN
</v-app-bar>
    </v-row>

         <v-row no-gutters>
          
             <v-col 
             class="pa-1 mt-4">
                  <v-card>
                      <v-card-text  >
                        <v-row no-gutter class="mb-4" v-if="!customer.id">
                              <v-text-field
                              v-model="customerID"
                              type="number"
                              label="Enter Customer No."
                              required
                              block
                              outlined
                              hide-details
                              append-icon="mdi-send"
                              @click:append = "customerLogin()"
                            ></v-text-field>
                        </v-row>
                        <v-row no-gutter>
                          <v-alert
                            v-if="customer.id==0"
                            dense
                            style="width: 100%"
                            class="mt-1"
                            text
                            type="error"
                            >
                            Account not found!
                            </v-alert>
                        </v-row>  
                         
                              <div class="text-left"><v-icon left color="info">mdi-account</v-icon>Name: {{customer.firstname}}</div>
                              <div class="text-left"><v-icon left color="info">mdi-numeric</v-icon>Acct. #: {{customer.email}}</div>

                         
                            <table class="va-table" v-if="paymentType == 'Credit'" style="width: 100%; margin-top: 30px;">
                              <tbody>
                                  <tr class="title">
                                            
                                            <td class="text-left" style="color:#5cb860">
                                              TOTAL SALES:
                                            </td>
                                         
                                            <td class="text-right"  style="color:#5cb860">
                                              <strong>{{$money(account.collectible)}}</strong>
                                            </td>
                                    </tr>
                                    <tr class="title">
                                           
                                          <td class="text-left"  style="color:#5cb860">
                                            TOTAL PAYMENTS:
                                            </td>
                                          
                                            <td class="text-right"  style="color:#5cb860">
                                                <strong>{{$money(account.payout)}}</strong>
                                            </td>
                                    </tr>
                                    <tr class="title">
                                           
                                           <td class="text-left"  style="color:#f55a4e; border-top: 1px solid #ddd;">
                                            BALANCE:
                                             </td>
                                           
                                             <td class="text-right"  style="color:#f55a4e; border-top: 1px solid #ddd;" >
                                                 <strong>{{$money(TOTAL_CURRENT_COLLECTIBLE)}}</strong>
                                             </td>
                                     </tr>
                                     <tr class="title" v-if="TOTAL_CURRENT_COLLECTIBLE>0">
                                        <td colspan="2" v-if="payform">
                                          <v-btn small color="secondary" block @click="setPayment(), payformpop= true">PAY</v-btn>
                                        </td>
                                        <td colspan="2" v-else>
                                                  <v-alert
                                                  dense
                                                  style="width: 100%"
                                                  class="mt-1"
                                                  text
                                                  type="info"
                                                  >
                                                 {{isPaidMsg}}
                                                  </v-alert>
                                        </td>
                                      </tr>

                                  </tbody>
                            </table>



                            <v-card class="elevation-0" style="margin-top: 40px;"  width="100%">
                                   <v-menu
                                   ref="menu"
                                   v-model="datemenu"
                                   :close-on-content-click="false"
                                   transition="scale-transition"
                                   offset-y
                               >
                                   <template v-slot:activator="{ on }">
                                   <v-text-field
                                       :value="selected_date"
                                       label="select date"
                                       prepend-icon="mdi-calendar"
                                       readonly
                                       dense
                                       single-line
                                       class="mr-2 sm-width"
                                       v-on="on"
                                   ></v-text-field>
                                   </template>
                          
                                    <v-date-picker class="ma-1" v-model="selected_date" no-title scrollable @input="datemenu = false, CurrentItems=[], getSale()" />
                               </v-menu>
                             </v-card>
                            <div style="margin-top: 30px;" class="text-h6">Collectible as of : {{$moment(selected_date).format(" MMM-DD, YYYY")}}</div>
                             <v-data-table
                             class="va-table"
                                 :headers="headers"
                                 :items-per-page="100"
                                 :items="CurrentItems"
                                 hide-default-footer
                                 >
                                 <template v-slot:body="{ items }">
                                  
                                     <tbody>
                                     <tr v-for="(item,index) in items" :key="index">
                                            
                                            <td class="text-left">
                                              
                                                <p style="margin-bottom: 3px"> <strong>{{ item.name }}</strong></p>
                                                 <p style="margin-bottom: 3px">Price/Kg: {{ $money(item.price) }}</p>
                                                 <p style="margin-bottom: 3px">Weight(Kg): {{ $money(item.kilos) }}</p>
                                                 <p style="margin-bottom: 3px"> Amount: {{ $money(parseFloat(item.kilos) * parseFloat(item.price)) }}</p>
                                             </td>
                                            
                                             <td class="text-right">
                                                 {{ $money(item.service_charge) }}
                                             </td>
                                             <td class="text-right">
                                                 {{ $money(item.trucking_fee) }}
                                             </td>
                                             <td class="text-right">
                                                 {{ $money(($IsNum(item.price) * $IsNum(item.kilos)) +  $IsNum(item.trucking_fee) + $IsNum(item.service_charge)) }}
                                             </td>
                                     </tr>
                                      <tr>
                                              <td class="text-right">
                                              
                                             </td>
                                             <td class="text-right">
                                                 {{ $money(SERVICE_CHARGE) }}
                                             </td>
                                             <td class="text-right">
                                                 {{ $money(TRUCKING_FEE) }}
                                             </td>
                                             <td class="text-right">
                                                 {{ $money(TOTAL_AMOUNT) }}
                                             </td>
                                     </tr>
                                  
                                     <tr class="title">
                                           
                                            <td colspan="2">
                                              Total:
                                            </td>
                                            <td class="text-right" colspan="2">
                                                {{ $money(TOTAL_AMOUNT) }}
                                            </td>
                                    </tr>   
                                    <tr class="title" v-if="TOTAL_AMOUNT>0">
                                           
                                           <td colspan="4">
                                            <v-btn small color="secondary" v-if="!snap" block @click="setPayment(), payformpop= true">PAY</v-btn>
                                            <v-alert
                                                v-else
                                                  dense
                                                  style="width: 100%"
                                                  class="mt-1"
                                                  text
                                                  type="info"
                                                  >
                                                 {{isPaidMsg}}
                                                  </v-alert>
                                           </td>
                                       
                                   </tr>
                                     </tbody>
                                 </template>
                           </v-data-table>
                      </v-card-text>
                    
                  </v-card>
             </v-col>
         </v-row>
         <va-my-pay-form :show="payformpop" :payment="payment" :customer="customer" :type="paymentType" @DialogEvent="payEvent" />
   </div>
 </template>
 <script>
 import { API_MIXINS } from '@/mixins/api_mixins.js'
 import {
   mapMutations
 } from 'vuex'
   export default {
     mixins: [API_MIXINS],
     data: () => ({
         form: false,
         paymentType:"Cash",
         cashierprint: false,
         payform: false,
         isPaidMsg:null,
         loading: false,
         payformpop: false,
         customer:{},
         payments:[],
         payment:{},
         postedpayments:[],
         customerID: "",
         snap:null,
         customers:[],
         CurrentItems:[],
         datemenu: false,
         sales:{},
         settings:[],
         state: 'update',
         selected_date: '',
         selected_date2: '',
         Fishcars:[],
         account:{},
         all_customers:[],
         _date: "",
         PaymentRef: null,
         headers:[
             {text: 'Fish', value: 'name', sortable: false},
              {text: 'SC', value: 'service_charge', sortable: false, align: 'right'},
             {text: 'Trucking', value: 'trucking_fee', sortable: false, align: 'right'},
             {text: 'Total',sortable: false, align: 'right'}
         ],
     }),
     beforeCreate: function () {
       
     },
     created() {
    //  this.PaymentRef = this.$refdb(this.$FBDB, 'payments');
        this.selected_date =  this.$moment().format('YYYY-MM-DD')
        this._date = "_" + this.$moment().format('YYYY-MM-DD')
     },
     computed:{
      SELECTED_DATE() {
        return this.selected_date
      },
      POSTED_PAYMENT(){
      let posted =  this.postedpayments.reduce((res, item) =>res += this.$IsNum(item.amount), 0)
      return posted
     },
     BALANCETODATE(){
      return this.TOTAL_AMOUNT - this.POSTED_PAYMENT
     },
       CANDOPAY() {
             if(!this.$session.get('permission')) {
               return true
             } 
             if(this.CHECKPERMISSION('Cash Only') || this.CHECKPERMISSION('Credit Only')) {
               return true
             }   
              return false
       },
       CUSTOMERTYPES(){
           if(!this.$session.get('permission')) {
                 return ["Cash", "Credit"]
             }
         if(this.CHECKPERMISSION('Cash Only')) {
             return ["Cash"]
         } else if(this.CHECKPERMISSION('Credit Only')) {
             return ["Credit"]
         } else {
            return ["Cash", "Credit"]
         }
           
       },
      AMOUNT() {
           var total = 0
             for(var i =0;i<this.CurrentItems.length;i++) {
               total += this.$IsNum(this.CurrentItems[i].price) * this.$IsNum(this.CurrentItems[i].kilos)
           }
           return total
       },
       KILOS() {
           var total = 0
             for(var i =0;i<this.CurrentItems.length;i++) {
               total += this.$IsNum(this.CurrentItems[i].kilos)
           }
           return total
       },
       SERVICE_CHARGE() {
           var total = 0
             for(var i =0;i<this.CurrentItems.length;i++) {
               total += this.$IsNum(this.CurrentItems[i].service_charge)
           }
           return total
       },
       TRUCKING_FEE() {
           var total = 0
             for(var i =0;i<this.CurrentItems.length;i++) {
               total += this.$IsNum(this.CurrentItems[i].trucking_fee)
           }
           return total
       },
       TOTAL_AMOUNT(){
           return this.AMOUNT + this.SERVICE_CHARGE + this.TRUCKING_FEE
       },
       FISHCARS(){
        return this.Fishcars
       },
       PAYBTN(){
         if(this.CurrentItems.length > 0) {
             return true
         } 
         return false
       },
       ITEM_IDS(){
          var ids = []
             for(var i =0;i<this.CurrentItems.length;i++) {
               ids.push(this.CurrentItems[i].id)
           }
           return ids
       },
       IS_PAID(){
          for(var i =0;i<this.payments.length;i++) {
               if(this.payments[i].type == 4) {
                   return true
               }
           }
           return false
      },
       SALESIDS() {
           var ids = []
             for(var i =0;i<this.CurrentItems.length;i++) {
               ids.push(this.CurrentItems[i].id)
           }
           return ids
       },
       TOTAL_CURRENT_COLLECTIBLE() {
         return this.$IsNum(this.account.collectible) - this.$IsNum(this.account.payout)
       }
     },
     methods: {
       ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
       confirmPayment(){
              if (confirm("Would you like to pay this balance?") == true) {
               // this.GenerateCode()
              } 
       },
       getPayment(){
      var param= {}
        param.start_date = this.selected_date
        param.account = this.customer.id
        console.log(param)
        this.$http.post("transaction/get_payment", param).then(response => { 
            this.postedpayments = response.data.data
        })
    },
       setPayment() {
         this.payment.amount = this.paymentType != 'Credit'?this.AMOUNT: this.TOTAL_CURRENT_COLLECTIBLE
         this.payment.total_amount = this.TOTAL_AMOUNT
         this.payment.service_charge = this.SERVICE_CHARGE
          this.payment.trucking_fee = this.TRUCKING_FEE
          this.payment.customer = this.customer.id 
         this.payment.items = this.ITEM_IDS
        
       },
       prEvent(){
         this.cashierprint =false
       },
       payEvent(){
           this.payformpop = false
         
       },
       formEvent(data){
         this.form = false
         if(data.action == 'update') {
             this.sales = data.sales
             this.Save()
         }
       },
       getFishcars: function() {
         this.$http.post("supplier/list", {}).then(response => {
               response.data.data != null?this.Fishcars = response.data.data:this.Fishcars=[]
           }).catch(e => {
            console.log(e.data)
          })
      },
        Save(){
             this.$http.post("sale/update", this.sales).then(response => {
             if(response.data.status == true) {
                 this.VA_ALERT('success', response.data.message)
             } else {
                 this.VA_ALERT('error', response.data.message)
             }
             // this.getTransactions()
             }).catch(e => {
             console.log(e)
             })
         },
         clear() {
           this.customer = {}
           this.CurrentItems = []
           this.account = {}
           this.payments = []
         },

       getSale(){
        this.PaymentRef = this.$refdb(this.$FBDB, 'payments/'+this.selected_date +"/"+this.customer.email);
         // this.getPayment()
           if(this.paymentType == 'Credit') { //1003014944
                this.getCreditSales()
             } else {
               this.getCashSales()
             }
       },
       GenerateCode() {
        let custURL = this.selected_date +"/"+this.customer.email
        let action = "Customer " +  this.customer.firstname + " Initiate payment on " + this.$moment().format('YYYY-MM-DD hh:mm:ss a')
        var data = {"acct": this.customer.email,
                "amt": this.AMOUNT,
                "logs": [
                  {
                    "action": action
                  }
                ],
                "sc": this.SERVICE_CHARGE,
                "status": "Initiated",
                "tf": this.TRUCKING_FEE,
        }
        this.$setdb(this.$refdb(this.$FBDB, 'payments/' + custURL), data);
        this.payform = false
       }, //1003014944
       readRef() {
        this.payform = false
        let dbRef= this.$refdb(this.$FBDB);
        this.$getdb(this.$childdb(dbRef, 'payments/'+this._date +"/"+this.customer.email)).then((snapshot) => {
                  if (snapshot.exists()) {
                    this.snap = snapshot.val()
                    this.payform = false
                    if(this.snap.status=="Initiated") {
                      this.isPaidMsg = "Payment already initiated! Please proceed to the cashier."
                      this.VA_ALERT('info', "Payment already initiated! Please proceed to the cashier.")
                    } else if (this.snap.status=="Payment Received") {
                      this.isPaidMsg = "Payment was already completed!"
                    }
                  } else {
                    this.payform = true
                  }
                }).catch((error) => {
                  console.error(error);
                });

       },
       
       customerLogin() {
        this.customer = {}
        this.paymentType == 'Cash'
         this.$http.post("customer/login", {email: this.customerID}).then(response => {
            response.data.customer != null?this.customer= response.data.customer:this.customer = {id:0}
            if(response.data.customer != null) {
                if(this.customer.credit == "enabled") {
                  this.paymentType = 'Credit'
                  this.getAccountSummary()
                } else {
                  this.paymentType = 'Cash'
                  this.getSale()
                }
                this.readRef()
            }
             }).catch(e => {
             console.log(e.data)
           }) 
      },

       getCashSales() {
         this.$http.post("customer/get_order", {id: this.customer.id, status: this.selected_date}).then(response => {
           response.data.data != null?this.CurrentItems = response.data.data:this.CurrentItems = []
             }).catch(e => {
             console.log(e.data)
           }) 
       },
       getCreditSales() {
        console.log("selected_date:  ", this.selected_date)
         this.$http.post("customer/get_credit_sales", {customer: this.customer.id, date: this.selected_date, date2: this.selected_date}).then(response => {
           response.data.data != null?this.CurrentItems = response.data.data:this.CurrentItems = []
           console.log(this.CurrentItems)
           this.getAccountSummary()
             }).catch(e => {
             console.log(e.data)
           }) 
       },
    getAccountSummary(){
         this.$http.post("transaction/query_total", {account: this.customer.id, account_type: 3}).then(response => {
               response.data.data != null?this.account = response.data.data:this.account={}
               console.log(this.account)
          }).catch(e => {
            console.log(e.data)
          })
      },
      
       loadSetting() {
           this.$http.post("setting/list", JSON.stringify({})).then(response => {
             response.data.data != null?this.settings = response.data.data:this.settings = []
           }).catch(e => {
            console.log(e.data)
          })
       },
       getSettingVal(name) {
           for(var i =0;i<this.settings.length;i++) {
               if(this.settings[i].name == name) {
                   return this.settings[i].value
               }
           }
           return false
       }
     }
   }
 </script>